export default basicGame = `

export default {
    "slug": "newGameSlug",
    "title": "Title goes here",
    "introduction": "a rough draft",
    "firstChapterKey": "startingChapterKey",
    "player": require("./player.js").default,
    "chapters": {chapterRequiresStrings
    },
    "configuration": {
        "darkness": false,
        "squigglevision": false,
    },
    "audio": {},
    "credits": [
        "Andrew Goodenough",
        "Doc McPherson",
        "Anna Arkhipova",
    ],
}
`
